<app-sidebar (close)="closeSentence()" [show]="selectedSentence">
  <app-statistics [sentence]="selectedSentence"></app-statistics>
  <div class="d-flex justify-center">
    <button (click)="closeSentence()" class="btn bg-primary rounded-full px-7">
      {{ "common_close" | translate }}
    </button>
  </div>
</app-sidebar>

<app-sidebar (close)="closeConditions()" [show]="isConditionsOpen">
  <app-conditions></app-conditions>
  <div class="d-flex justify-center">
    <button
      (click)="closeConditions()"
      class="btn bg-primary rounded-full px-5"
    >
      {{ "common_close" | translate }}
    </button>
  </div>
</app-sidebar>

<app-cancel-open-banking-popin
  (continue)="closeCancelPopin()"
  [isCancelPopinOpen]="isCancelPopinOpen"
  [isRefusingConsent]="true"
>
</app-cancel-open-banking-popin>

<form class="w-full max-w-600px" (ngSubmit)="onAccepted()">
  <div class="text-center mb-10">
    <span class="text-primary picto-bank-switch picto-size-13"></span>
    <h1 class="font-20 font-md-28 mt-5">
      {{ "common_autorisation" | translate }}
      <br />
      {{ "common_autorisation_info" | translate }}
    </h1>
  </div>

  <div class="text-justify font-14 font-md-15">
    <p>{{ "information_text1" | translate }}</p>
    <p>{{ "information_text2" | translate }}</p>
  </div>

  <div
    *ngFor="let sentence of openBankingObjectivesSentences; index as i"
    class="d-flex p-2"
  >
    <span class="text-lightgray picto-puce-right picto-size-3 pr-2"></span>
    <div class="font-14 font-md-15">
      {{ sentence.title }}
      <br /><a (click)="openSentence(i)" class="font-13" role="button">
        {{ "information_find_out_more" | translate }}
      </a>
    </div>
  </div>

  <div class="text-justify font-14 font-md-15">
    <p [innerHTML]="'information_details_text1' | translate"></p>
    <p>
      {{ "information_details_text2" | translate }}
      <a (click)="openConditions()" role="button">{{
        "information_details_click" | translate
      }}</a
      >.
    </p>
  </div>

  <div class="mb-10 form-check">
    <input
      [(ngModel)]="conditionAccepted"
      [ngModelOptions]="{ standalone: true }"
      id="acceptationConditions"
      name="consent"
      type="checkbox"
    />
    <label
      for="acceptationConditions"
      class="ml-4 text-justify font-14 font-md-15"
    >
      {{ "information_check" | translate }}
      <a (click)="openCGU($event)" class="text-dark" role="button">{{
        "information_check_more" | translate
      }}</a>
    </label>
  </div>

  <div class="d-flex justify-between">
    <button
      (click)="openCancelPopin()"
      class="btn bg-gray rounded-full px-7 px-md-8"
      type="button"
    >
      <span class="picto-close"></span>
      {{ "common_refuse" | translate }}
    </button>
    <button
      [disabled]="!conditionAccepted"
      class="btn bg-primary rounded-full px-7 px-md-8"
      type="submit"
    >
      <span class="picto-check"></span>
      {{ "common_accept" | translate }}
    </button>
  </div>
</form>
